// Accounts Chart Vuex

import state from './chartOfAccountStates.js'
import * as getters from './chartOfAccountGetters.js'
import * as mutations from './chartOfAccountMutations.js'
import * as actions from './chartOfAccountActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
